<template>
	<nav
		class="action-set-nav"
		:class="{ 'is-active': display }"
		v-if="display"
	>
		<span class="action-set-nav__name">{{ name }}</span>
		<ActionsSet
			class="action-set-nav__actions"
			:variant="variant"
			:options="actions"
			:baseClass="'page-set'"
			:baseSubClass="'page-set__submenu'"
		/>
	</nav>
</template>

<script>
import ActionsSet from '@/site-components/actions-set/actions-set';

export default {
	name: 'ActionSetNav',
	components: {
		ActionsSet
	},
	props: {
		display: {
			type: Boolean,
			default: false
		},
		name: {
			type: String,
			default: ''
		},
		actions: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss">
/**
    * Action Set Navigation
    * Action Set Subnav
    * Can use SCSS variables = TRUE
 */

.action-set-nav {
	display: flex;
	justify-content: space-between;
	background-color: $customer-nav-bkgd;
	box-shadow: $customer-nav-shadow;
	align-items: center;
	padding: $padding-xs $padding-sm;
	min-height: 38px;

	@include mq($from: md) {
		max-width: 500px;
		margin: 0 auto;
	}

	&__name {
		font-weight: $medium-font-weight;
		line-height: normal;
		max-width: calc(100% - 300px);
		font-size: $default-font-size - 2;
		@include ellipsis;

		@include mq($until: md) {
			max-width: calc(100% - 160px);
		}
	}
}

.page-set {
	text-align: right;
	list-style: none;
	padding-inline-start: 0;
	position: relative;
	margin-block-start: 0;
	margin-block-end: 0;

	&__item {
		display: inline-block;
		vertical-align: middle;
		text-align: center;
		margin-left: $gutter-sm;
	}

	&__action {
		padding: $padding-xs;
		min-width: 50px;
		border-bottom: 2px solid transparent;
		margin-bottom: -2px;

		&:focus,
		&:hover,
		&:active,
		&.is-active {
			color: $base;
			border-bottom: 2px solid $base;
			outline: 0;
		}
	}

	&__icon {
		margin-right: $gutter-sm;
		vertical-align: middle;
		font-size: $default-font-size;
	}

	&__label {
		font-size: $default-font-size - 5;
		font-weight: $medium-font-weight;

		@include mq($until: md) {
			display: none;
		}
	}
}

.page-set__more {
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	cursor: pointer;
	outline: 0;
	border: 0;
	padding: $padding-xs $padding-sm;
	background-color: $neutral-4;
	display: inline-block;
	vertical-align: middle;
	text-align: center;
	margin-left: $gutter-sm;

	&:focus,
	&:hover,
	&:active {
		background-color: $neutral-3;
		@include text-contrast($neutral-3, $white, $black);
		border-bottom: none;
	}

	.page-set__icon {
		margin-right: 0;
	}
}

.page-set__submenu {
	display: none;
	box-shadow: 0px 2px 4px $neutral-3;
	border-radius: $customer-subnav-border-radius;
	padding: $padding-xs 0;
	background-color: $white;
	@include text-contrast($white, $white, $black);
	position: absolute;
	right: 0;
	z-index: 1;
	text-align: left;
	overflow: hidden;
	transition-timing-function: ease-in-out;
	transition: 0.4s;

	&.is-open {
		display: block;
	}

	&-action {
		display: inline-block;
		width: 100%;
		padding: $padding-xs $padding-sm;

		&:focus,
		&:hover {
			background: lighten($neutral-4, 5%);
			@include text-contrast(lighten($neutral-4, 5%), $white, $black);
		}

		&:active,
		&.is-active {
			background: $neutral-4;
			@include text-contrast($neutral-4, $white, $black);
		}
	}

	&-icon {
		margin-right: $gutter-md;
		vertical-align: middle;
	}

	&-label {
		vertical-align: middle;
		font-size: $default-font-size - 5;
	}
}
</style>
